import type { Action } from "../../actions/types";
import { currencySymbols } from "../../utils/currencies";

export type LedgerHead = {
  total: number;
  currency: string;
  defaultExchangeValue?: number;
};

export type LedgerContext = {
  usingPointsLedger?: boolean;
  usingAccountCredit?: boolean;
  storeCurrency?: string;
  loyaltyCurrency?: string | null;
  userLedgerHeads?: LedgerHead[];
  value?: string;
};

export type StoreState = LedgerContext;

export const initialState: StoreState = {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState | null {
  if (action.type === "LOYALTY_GET_LEDGER_CONTEXT_SUCCESS") {
    const data = action.response.data as LedgerContext;

    // expose current value as convenient merge variable, i.e. {{LedgerContext.value}}
    const value = () => {
      const storeCurrency = data.storeCurrency || "";
      const symbol = currencySymbols[storeCurrency] || "";
      let value = 0;

      if (data.loyaltyCurrency && data.userLedgerHeads) {
        const head = data.userLedgerHeads.find(
          (head) => head.currency === data.loyaltyCurrency
        );

        if (head && head.defaultExchangeValue) {
          value = head.defaultExchangeValue;
        }
      }

      return `${symbol}${value}`;
    };

    return { ...action.response.data, value: value() };
  }

  return state;
}
